<div class="notifications-wrapper">
  <button
    mat-icon-button
    type="button"
    class="notifications-button"
    [matMenuTriggerFor]="notificationsMenu"
    (menuOpened)="onMenuOpened()"
    aria-label="Notifications"
    [matTooltip]="unreadCount ? unreadCount + ' unread' : 'Notifications'"
  >
    <mat-icon
      [matBadge]="badgeText"
      [matBadgeHidden]="badgeHidden"
      matBadgeColor="warn"
      matBadgeSize="small"
    >notifications</mat-icon>
  </button>

  <!-- [@.disabled] avoids Angular animation startTime races when CD runs mid open/close. -->
  <mat-menu #notificationsMenu="matMenu" class="notifications-menu" xPosition="before" [@.disabled]="true">
    <div class="notifications-header" (click)="$event.stopPropagation()">
      <span class="notifications-title">Notifications</span>
      <button
        *ngIf="unreadCount > 0"
        mat-button
        type="button"
        class="mark-all-btn"
        (click)="onMarkAllRead($event)"
      >
        Mark all read
      </button>
    </div>
    <mat-divider></mat-divider>

    <div class="notifications-body" (click)="$event.stopPropagation()">
      <div *ngIf="loading" class="notifications-empty">Loading…</div>
      <div *ngIf="!loading && items.length === 0" class="notifications-empty">
        No notifications
      </div>

      <button
        *ngFor="let item of items"
        type="button"
        class="notification-item"
        [class.unread]="!item.isRead"
        (click)="onItemClick(item, $event)"
      >
        <div class="notification-text">
          <div class="notification-item-title">{{ item.title }}</div>
          <div class="notification-item-message">{{ item.message }}</div>
          <div class="notification-item-time">{{ timeLabel(item) }}</div>
        </div>
        <span *ngIf="!item.isRead" class="unread-dot" aria-hidden="true"></span>
      </button>
    </div>
  </mat-menu>

  <div class="notification-toast-stack" *ngIf="enableToasts && toasts.length" aria-live="polite">
    <div
      *ngFor="let toast of toasts"
      class="notification-toast"
      role="status"
    >
      <button
        type="button"
        class="notification-toast-body"
        (click)="onToastBodyClick(toast, $event)"
      >
        <div class="notification-toast-title">{{ toast.title }}</div>
        <div class="notification-toast-message">{{ toast.message }}</div>
      </button>
      <button
        type="button"
        class="notification-toast-close"
        aria-label="Dismiss notification"
        (click)="onToastCloseClick(toast, $event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
